import React, { useState } from 'react';
import styles from './sign-in-form.module.scss';
import { DefaultButton, FormButtonBack, FormInput } from 'shared/ui';
import { signIn } from 'features';
import { validateInputs } from 'shared/lib';
import { classificationLogin } from '../model/classification-login';
import { TLoginState } from '../types/types';
import { SignInErrors } from 'shared/consts/sign-in.error';
import { userStore } from 'entities/index';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { observer } from 'mobx-react';

export const SignInForm: React.FC = observer(() => {
  const [login, setLogin] = useState<TLoginState>({ type: false, value: '' });
  const [password, setPassword] = useState('');
  const [validationError, setValidationError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (isLoading) return;

    const formData = classificationLogin(login);

    if (!formData.type) {
      setValidationError(SignInErrors.INCORRECT_EMAIL_OR_PHONE);
      return;
    }

    if (!validateInputs.validatePassword(password)) {
      setValidationError(SignInErrors.INCORRECT_PASSWORD);
      return;
    }

    setIsLoading(true);
    try {
      await signIn(formData.type, formData.value, password);
      userStore.redirectToRoleBasedPage(navigate);
    } catch (error) {
      if (error instanceof Error) {
        setValidationError(error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className={styles.sign_in} onKeyDown={handleKeyDown}>
      <div className={styles.sign_in__content}>
        <div className={styles.sign_in__title}>Вход</div>
        <div className={styles.sign_in__inputs}>
          <div className={styles.inputs__input}>
            <FormInput
              inputTitle="Почта или номер телефона"
              inputPlaceholder="Почта или номер телефона"
              onChange={(value) => {
                setValidationError('');
                setLogin((prev) => ({
                  ...prev,
                  value: value,
                }));
              }}
            />
          </div>
          <div className={styles.inputs__input}>
            <FormInput
              inputType="password"
              showPasswordToggle
              inputTitle="Пароль"
              inputPlaceholder="Пароль"
              onChange={(value) => {
                setValidationError('');
                setPassword(value);
              }}
            />
          </div>
        </div>
        <div className={styles.sign_in__buttons}>
          {validationError ? (
            <div className={styles.buttons__error}>{validationError}</div>
          ) : undefined}
          <div className={styles.buttons__button_submit} onClick={handleSubmit}>
            <DefaultButton
              buttonText="Войти"
              color="white"
              disabled={isLoading}
            />
          </div>
          <div className={styles.buttons__button_back}>
            <FormButtonBack />
          </div>
          <div
            className={styles.buttons__forgot}
            onClick={() => navigate(AppLinks.EmailConfirmationLink)}
          >
            Забыли пароль?
          </div>
        </div>
      </div>
    </div>
  );
});
